import { Icon, IconProps } from "@looksrare/uikit";

const EmailIcon = (props: IconProps) => (
  <Icon viewBox="0 0 96 96" {...props}>
    <rect width="96" height="96" rx="48" fill="url(#paint0_linear_1201_1530)" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M66 33H30C28.3431 33 27 34.3431 27 36V60C27 61.6569 28.3431 63 30 63H66C67.6569 63 69 61.6569 69 60V36C69 34.3431 67.6569 33 66 33ZM62.7 36L48 46.17L33.3 36H62.7ZM30 60V37.365L47.145 49.23C47.6592 49.5867 48.3408 49.5867 48.855 49.23L66 37.365V60H30Z"
      fill="#F3F3F8"
    />
    <defs>
      <linearGradient id="paint0_linear_1201_1530" x1="48" y1="0" x2="48" y2="96" gradientUnits="userSpaceOnUse">
        <stop stopColor="#4D5358" stopOpacity="0.6" />
        <stop offset="1" stopColor="#4D5358" stopOpacity="0.2" />
      </linearGradient>
    </defs>
  </Icon>
);

export default EmailIcon;
